import React from "react";
import "./../Styles/policy.css";
export default function Policy() {
  return (
    <div>
      <div className="policy-page">
        <div className="policy-container">
          <div className="policy-card">
            <h1 className="policy-title">Terms & Conditions</h1>

            <p className="policy-subtitle">
              Life Time Creation Policies & Guidelines
            </p>

            <div className="policy-section">
              <h3>Change in Terms and Conditions</h3>
              <p>
                LifeTime Creation reserves the right to change any terms and
                conditions contained in this agreement or any policy or
                guideline of the website, at any time and in its sole
                discretion. Your continued use of the website following the
                posting of such changes will constitute your acceptance of such
                changes.
              </p>
            </div>

            <div className="policy-section">
              <h3>Cancellation Policy</h3>
              <p>
                LifeTime Creation believes in helping its customers as far as
                possible, and has therefore a liberal cancellation policy. Under
                this policy: in case you feel that the product received is not
                as shown on the site or not as per details provided by designer,
                you must bring it to the notice within 24 hours of receiving the
                product. The customer service team after looking into your
                complaint will take an appropriate decision.
              </p>
            </div>

            <div className="policy-section">
              <h3>Refund Policy</h3>

              <div className="policy-highlight">
                <p>
                  LifeTime Creation does not offer refunds or re-credits for
                  downloaded files.file returns will only be considered based on
                  technical issues with the file at the sole discretion of
                  LifeTime Creation. The company reserves the right to first
                  exercise resolving the technical issue that may include
                  offline correction of final artwork for customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
